import { render, staticRenderFns } from "./Affiches.vue?vue&type=template&id=783afb5d&scoped=true"
import script from "./Affiches.vue?vue&type=script&lang=js"
export * from "./Affiches.vue?vue&type=script&lang=js"
import style0 from "./Affiches.vue?vue&type=style&index=0&id=783afb5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783afb5d",
  null
  
)

export default component.exports